import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';
import { AppShell } from '@/components/shell/AppShell';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { LandingPage } from '@/pages/Landing';
import { LoginPage } from '@/pages/Login';
import { AuthCallbackPage } from '@/pages/AuthCallback';
import { WorkspacesPage } from '@/pages/Workspaces';
import { WorkspaceDetailPage } from '@/pages/WorkspaceDetail';
import { ProjectsTab } from '@/pages/workspace/ProjectsTab';
import { MembersTab as WorkspaceMembersTab } from '@/pages/workspace/MembersTab';
import { LanguagesTab } from '@/pages/workspace/LanguagesTab';
import { WorkspaceSettingsTab } from '@/pages/workspace/SettingsTab';
import { ProjectDetailLayout } from '@/pages/ProjectDetail';
import { ProjectSettingsTab } from '@/pages/project/SettingsTab';
import { ProjectMembersTab } from '@/pages/project/MembersTab';
import { ProjectImportTab } from '@/pages/project/ImportTab';
import { ProjectExportTab } from '@/pages/project/ExportTab';
import { ProjectPublishTab } from '@/pages/project/PublishTab';
import { TranslateTab } from '@/pages/project/TranslateTab';
import { GlossaryTab } from '@/pages/project/GlossaryTab';

// Public docs (COR-970). Lazy so the Markdown corpus, the renderer and
// highlight.js stay out of the main bundle.
const DocsSection = lazy(() => import('@/pages/docs/DocsSection'));

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/docs/*"
        element={
          <Suspense
            fallback={
              <div className="grid h-full place-items-center">
                <Spinner label="Loading documentation…" />
              </div>
            }
          >
            <DocsSection />
          </Suspense>
        }
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/auth/silent-renew" element={<div />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/workspaces" element={<WorkspacesPage />} />
        <Route path="/workspaces/:wsId" element={<WorkspaceDetailPage />}>
          <Route index element={<ProjectsTab />} />
          <Route path="members" element={<WorkspaceMembersTab />} />
          <Route path="languages" element={<LanguagesTab />} />
          <Route path="settings" element={<WorkspaceSettingsTab />} />
        </Route>
        <Route path="/workspaces/:wsId/projects/:projId" element={<ProjectDetailLayout />}>
          <Route index element={<ProjectSettingsTab />} />
          <Route path="translate" element={<TranslateTab />} />
          <Route path="glossary" element={<GlossaryTab />} />
          <Route path="members" element={<ProjectMembersTab />} />
          <Route path="import" element={<ProjectImportTab />} />
          <Route path="export" element={<ProjectExportTab />} />
          <Route path="publish" element={<ProjectPublishTab />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/workspaces" replace />} />
    </Routes>
  );
}
